import { useEffect } from 'react';

// Re-runnable reveal-on-scroll. Observes all .reveal nodes present at call time.
export default function useReveal() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }),
      { threshold: 0.12 }
    );
    const observe = () => document.querySelectorAll('.reveal:not(.in)').forEach((el) => io.observe(el));
    observe();
    const t = setTimeout(observe, 120);
    return () => { clearTimeout(t); io.disconnect(); };
  }, []);
}
